import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { MotionPathPlugin } from 'gsap/dist/MotionPathPlugin';

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);
const mm = gsap.matchMedia();

// eslint-disable-next-line
export const animation = () => {
  [].slice.call(document.querySelectorAll('.facing-section-horizontal, .gallery-plate')).forEach((elem) => {
    const leftCloud = elem.querySelector('.cloud.cloud--left');
    const rightCloud = elem.querySelector('.cloud.cloud--right');
    if (leftCloud || rightCloud) {
      mm.add('(min-width: 1280px)', () => {
        if (leftCloud) {
          gsap.to(leftCloud, {
            scrollTrigger: {
              trigger: elem,
              scrub: true,
              start: 'top 50%',
              end: 'bottom 100%',
            },
            translateX: -1000,
          });
        }
        if (rightCloud) {
          gsap.to(rightCloud, {
            scrollTrigger: {
              trigger: elem,
              scrub: true,
              start: 'top 50%',
              end: 'bottom 100%',
            },
            translateX: 1000,
          });
        }
      });
    }
  });

  [].slice.call(document.querySelectorAll('.js-canvas-lens')).forEach((elem) => {
    if (elem) {
      mm.add('(min-width: 1280px)', () => {
        gsap.to(elem, {
          scrollTrigger: {
            trigger: elem,
            scrub: true,
            start: 'top top',
            end: '500% 100%',
          },
          rotation: 75,
        });
      });
    }
  });

  [].slice.call(document.querySelectorAll('.decor.decor--bike')).forEach((elem) => {
    const bike = elem.querySelector('.decor__bike-wrapper');
    if (bike) {
      mm.add('(min-width: 1280px)', () => {
        gsap.to(bike, {
          scrollTrigger: {
            trigger: elem,
            start: 'bottom bottom',
            end: 'bottom -150%',
            scrub: true,
            onUpdate(self) {
              bike.classList.toggle('decor__bike-wrapper--back', self.direction === -1);
            },
          },
          translateX: elem.offsetWidth,
        });
      });
    }
  });

  [].slice.call(document.querySelectorAll('.topProjects .topProjects__decor')).forEach((elem) => {
    const backImage = elem.querySelector('.topProjects__decor-back');
    const frontImage = elem.querySelector('.topProjects__decor-front');
    if (backImage || frontImage) {
      mm.add('(min-width: 1280px)', () => {
        if (backImage) {
          gsap.to(backImage, {
            scrollTrigger: {
              trigger: backImage,
              scrub: true,
              start: 'top 75%',
              end: 'bottom center',
            },
            rotate: -15,
          });
        }
        if (frontImage) {
          gsap.to(frontImage, {
            scrollTrigger: {
              trigger: frontImage,
              scrub: true,
              start: 'top 75%',
              end: 'bottom center',
            },
            rotate: 20,
          });
        }
      });
    }
  });

  [].slice.call(document.querySelectorAll('.location')).forEach((elem) => {
    const decor = elem.querySelector('.location__decor');
    if (elem && decor) {
      mm.add('(min-width: 1280px)', () => {
        gsap.to(decor, {
          scrollTrigger: {
            trigger: elem,
            scrub: true,
            start: 'top 25%',
            end: elem.classList.contains('location--without-slider') ? 'bottom 65%' : 'top top',
          },
          translateY: '-100%',
        });
      });
    }
  });

  [].slice.call(document.querySelectorAll('.facing-section-horizontal')).forEach((elem) => {
    const items = [].slice.call(elem.querySelectorAll('.facing-section-horizontal__decor-item'));
    if (items.length) {
      items.forEach((item) => {
        mm.add('(min-width: 1280px)', () => {
          gsap.to(item, {
            scrollTrigger: {
              trigger: elem,
              start: '120px bottom',
              end: 'bottom bottom',
            },
            duration: 5,
            motionPath: {
              path: `#${item.getAttribute('data-id')}`,
              align: `#${item.getAttribute('data-id')}`,
              autoRotate: true,
              alignOrigin: [0.5, 0.5],
            },
          });
        });
      });
    }
  });
};



// WEBPACK FOOTER //
// ./new-blocks/animations/animations.js